import _WidgetBase from "dijit/_WidgetBase";
import declare from "dojo/_base/declare";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Time from "csi/heading/Time";
import types from "csi/types";
import { shiftUTCDateToLocal } from "csi/utility/dateUtility";
import Spec from "./Spec";

const UniversalDate = declare(Time, {
	/**
	 * @property {boolean} bTestFormat - set to true if inheriting a RendererClass from this for OOTB attribute so that
	 * it could work with either Date or Universal Date format
	 */
	bTestFormat: false,

	/**
	 * @property {number} hours - optional hours parameter to add to universal date when setting it.
	 */
	hours: 0,

	/**
	 * @override
	 * Return attribute value from edit control. For Universal Time format, we'll have to get the timezone offset
	 * and add it to the current minutes on current time zone minutes and it'll be UTC Date object.
	 */
	fromHtmlDynamic(ctx: Context, h: Heading, editNode: _WidgetBase & Element): number {
		if (!this.bTestFormat) {
			var dt = editNode.get("value");
			return dt && (dt instanceof Date) ? types.getUTCDateTime(dt, this.hours) : 0;
		}
		return this.inherited<number>(arguments);
	},

	/**
	 * @override
	 * Returns the UTC date without considering the time-zone of client machine
	 */
	_addDynamicParams(ctx: Context, h: Heading, params): void {
		if (!this.bTestFormat) {
			if (params.constraints == null) {
				params.constraints = this._constraints;
			}
			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}
			params.value = params.value ? types.getUTCTimeDate(params.value) : null;
		} else {
			this.inherited(arguments);
		}
	},

	/**
	 * @override
	 * converts given value to work with UTC time
	 */
	getClientFilteredValue: function (ctx: Context, spec: Spec, value: number): number {
		if (spec.heading.m_format === types.UNIVERSAL_DATE) {
			return shiftUTCDateToLocal(value).getTime();
		} else {
			return value;
		}
	},
});

export = UniversalDate;